<template>
  <iframe
    v-if="id"
    width="100%"
    height="100%"
    :src="`https://www.youtube.com/embed/${id}?autoplay=${Number(
      autoplay,
    )}&mute=${Number(muted)}`"
    :class="{ 'h-full w-full object-cover': containerSize }"
    frameborder="0"
    allow="
      accelerometer;
      autoplay;
      clipboard-write;
      encrypted-media;
      gyroscope;
      picture-in-picture;
    "
    allowfullscreen
  />
</template>

<script setup lang="ts">
interface Props {
  id?: string;
  autoplay?: boolean;
  muted?: boolean;
  containerSize?: boolean;
}
withDefaults(defineProps<Props>(), {
  id: '',
  autoplay: true,
  muted: true,
  containerSize: false,
});
</script>
